import { defa } from 'defa-object';

/**
 * defa.views.TermsAndConditionsView
 * A view for accepting terms and conditions.
 * @version 1.0.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/termsAndConditions.jst.html'

const selectors = {
	inputAccept : '[data-input=terms-accept]',
	buttonExit  : '[data-click=terms-exit]',
	buttonOut   : '[data-click=terms-out]',
	
};

const TermsAndConditionsView = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template         : template,
	className        : 'card card-terms ',
	noInitValidation : true,
	
	ui: {
		accept : selectors.inputAccept,
		exit   : selectors.buttonExit,
		out    : selectors.buttonOut,
	},
	
	events: {
		'click  @ui.exit'   : 'onClickExit',
		'click @ui.out'     : 'onClickOut',
	},
	
	
	templateContext: function() {
		
		return {
			isAccepted : this.options.isAccepted,
			terms      : this.options.terms,
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Triggers when a user clicks the close button.
	 * @void
	 */
	onClickExit: function (event) {
		event.preventDefault();
		this.busy();
		$( '[data-click="open-terms-and-conditions"]' ).trigger( 'terms:closed');
	},
	
	/**
	 * Triggers when a user clicks the close button.
	 * @void
	 */
	onClickOut: function (event) {
		event.preventDefault();
		// Shut down native app
		$( '[data-click="open-terms-and-conditions"]' ).trigger( 'terms:canceled');
	},
	
	/**
	 * Validates the form by verifying the accept terms and conditions checkbox is checked.
	 * @void
	 */
	validate: function () {
		return this.ui.accept.is( ':checked' );
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		this.busy();
		$( '[data-click="open-terms-and-conditions"]' ).trigger( 'terms:accepted');
	},
	
} );

export default TermsAndConditionsView;